import React from 'react';
import PropTypes from 'prop-types';

const Close = ({ color }) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="05_matcher_ui-version_02"
        transform="translate(-42.000000, -449.000000)"
        stroke={color || '#3C3C3C'}
        strokeWidth="2"
      >
        <g id="Nope" transform="translate(28.000000, 434.000000)">
          <path d="M33,34 L15,16 M15,34 L33,16" id="Combined-Shape" />
        </g>
      </g>
    </g>
  </svg>
);

Close.propTypes = {
  color: PropTypes.string
};

Close.defaultProps = {
  color: '#3C3C3C'
};

export default Close;
